var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"ibox float-e-margins color-1\"><div class=\"ibox-title\"><h5>YTD Purchases</h5></div><div class=\"ibox-content\"><h2 class=\"no-margins\">{{$ctrl.ytdSales.total|currency}}</h2><div><small>Last Year's Totals <strong>{{$ctrl.lySales.total|currency}}</strong></small></div></div></div>";
var id1="dashboard-ytdsales.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;